module.exports = __webpack_public_path__ + "img/futureweb_more.fbfb15d0.svg";